<div mat-dialog-content>
  <br />
  <img src="/assets/heart.svg" />
  <h3>Thanks for submitting!</h3>
  <p>
    Sit back and relax - we will be in contact with you soonest with feedback on
    your ZeroPay partner signup. If you have any urgent questions, get in touch
    with us.
  </p>
  <p>
    <a mat-button href="tel:+27872100336">087 2100 336</a> |
    <a mat-button href="mailto:partners@zeropay.co.za"
      >partners@zeropay.co.za</a
    >
  </p>
</div>
